import {defineMessage} from 'react-intl';
import * as React from 'react';
import {setup, run} from '../../snippets/java';
import comment from '../../snippets/comment';
import {CreateShellCommand} from '../../../components/left-col';

export const steps = {
  setup,
  create: {},
  imports: {
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.server.java.imports.body',
        defaultMessage:
          'Import the Stripe PaymentMethod and Customer models. Use these models to store information about your Customer.',
      }),
    },
  },
  customer: {},
  'pass-customer': {},
  charge: {},
  'run-server': {
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.server.java.run-server.body',
        defaultMessage:
          'Run your server and go to <a>localhost:4242/checkout.html</a>.',
      }),
      values: {
        a: (str) => (
          <a href="http://localhost:4242/checkout.html" target="_blank">
            {str}
          </a>
        ),
      },
    },
    Component: CreateShellCommand(run('accept-card-payment')),
  },
};

export default ({keys, merchant}) => `package com.stripe.sample;

import java.nio.file.Paths;

import static spark.Spark.get;
import static spark.Spark.post;
import static spark.Spark.staticFiles;
import static spark.Spark.port;

import com.google.gson.Gson;
import com.google.gson.annotations.SerializedName;

import com.stripe.Stripe;
import com.stripe.model.PaymentIntent;
import com.stripe.param.PaymentIntentCreateParams;
{?save-card imports}
import com.stripe.model.PaymentMethod;
import com.stripe.model.Customer;
import com.stripe.model.PaymentMethodCollection;
import com.stripe.param.CustomerCreateParams;
import com.stripe.param.PaymentMethodListParams;
import com.stripe.exception.StripeException;
{/imports}

public class Server {
  private static Gson gson = new Gson();

  static class CreatePayment {
    @SerializedName("items")
    Object[] items;

    public Object[] getItems() {
      return items;
    }
  }

  static class CreatePaymentResponse {
    private String clientSecret;

    public CreatePaymentResponse(String clientSecret) {
      this.clientSecret = clientSecret;
    }
  }

  static int calculateOrderAmount(Object[] items) {
    // Replace this constant with a calculation of the order's amount
    // Calculate the order total on the server to prevent
    // users from directly manipulating the amount on the client
    return 1400;
  }

  {?save-card charge}
  // Call this function with the ID of the Customer you want to charge
  static void chargeCustomer(String customerId) {
    try {
      // List the customer's payment methods to find one to charge
      PaymentMethodListParams listParams = new PaymentMethodListParams.Builder().setCustomer(customerId)
          .setType(PaymentMethodListParams.Type.CARD).build();

      PaymentMethodCollection paymentMethods = PaymentMethod.list(listParams);

      PaymentIntentCreateParams createParams = new PaymentIntentCreateParams.Builder().setCurrency("usd")
          .setAmount(new Long(1099))
          .setPaymentMethod(paymentMethods.getData().get(0).getId())
          .setCustomer(customerId)
          .setConfirm(true)
          .setOffSession(PaymentIntentCreateParams.OffSession.ONE_OFF).build();

      PaymentIntent paymentIntent = PaymentIntent.create(createParams);
      if (paymentIntent.getStatus().equals("succeeded")) {
        System.out.println("Payment suceeded");
      }
    } catch (StripeException e) {
      System.out.println("Error from Stripe: " + e.getMessage());
    }
  }

  {/charge}
  public static void main(String[] args) {
    port(4242);
    staticFiles.externalLocation(Paths.get("public").toAbsolutePath().toString());

    {+setup}
    ${comment && comment(merchant)}
    Stripe.apiKey = "${keys.secret}";
    {/setup}

    post("/create-payment-intent", (request, response) -> {
      response.type("application/json");
      {?save-card customer}
      // Alternatively, set up a webhook to listen for the payment_intent.succeeded event
      // and attach the PaymentMethod to a new Customer
      CustomerCreateParams customerParams = new CustomerCreateParams.Builder().build();
      Customer customer = Customer.create(customerParams);
      {/customer}

      {+create}
      CreatePayment postBody = gson.fromJson(request.body(), CreatePayment.class);
      PaymentIntentCreateParams createParams = new PaymentIntentCreateParams.Builder()
      .setCurrency("usd")
      .setAmount(new Long(calculateOrderAmount(postBody.getItems())))
      {?save-card pass-customer}
      .setCustomer(customer.getId())
      .setSetupFutureUsage(PaymentIntentCreateParams.SetupFutureUsage.OFF_SESSION)
      {/pass-customer}
      .build();
      // Create a PaymentIntent with the order amount and currency
      PaymentIntent {span response create}intent{/span} = PaymentIntent.create(createParams);

      CreatePaymentResponse paymentResponse = new CreatePaymentResponse(intent.getClientSecret());
      return gson.toJson(paymentResponse);
      {/create}
    });
  }
}`;
